<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">（数据来源：国家文物局博物馆与社会文物司）</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入博物馆名称"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging">
            <el-select
              v-model="province"
              clearable
              placeholder="省份"
              class="province"
              @change="provinceChange()"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="nature"
              clearable
              placeholder="性质"
              class="nature"
              @change="natureChange()"
            >
              <el-option
                v-for="item in natureList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="grade"
              clearable
              placeholder="质量等级"
              class="grade"
              @change="gradeChange()"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              :index="count"
              label="总序"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="proName"
              label="省份"
              min-width="105px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="collectionName"
              label="博物馆名称"
              min-width="150px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="collectionNatureName"
              label="性质"
              min-width="80px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="collectionQualityLevelName"
              label="质量等级"
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="openFlag"
              label="是否免费开放"
              min-width="90px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="crNum"
              label="藏品数（件/套）"
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="valuableNum"
              label="珍贵文物（件/套）"
              min-width="90px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="exhibitionNum"
              label="展览（个）"
              min-width="90px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="educationActivityNum"
              label="教育活动（次）"
              min-width="90px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="attendanceNum"
              label="参观人数（万人次）"
              min-width="100px"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_MUSEUM_DIRECTORY,
  URL_COMPREHENSIVE_EXCUSE,
} from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "",
        // 浏览次数
        num: "2",
      },
      // 省份
      provinceList: [],
      //省份
      province: null,
      //性质
      natureList: [],
      //性质
      nature: null,
      // 质量等级
      gradeList: [],
      // 质量等级
      grade: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      //  根据传值判断是否免费  1是
      sta: 1,
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 100,
      // 页大小
      pagesize: 10,
    };
  },
  computed: {},
  methods: {
    // 请求列表数据
    getList() {
      let result = frontHeater(["districtCode"], [this.province]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pagesize,
        collectionName: this.searchOn,
        districtCode: this.province,
        collectionNatureName: this.nature,
        collectionQualityLevelName: this.grade,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["districtCode"] = this.province;
      this.$http.get(Url + URL_MUSEUM_DIRECTORY, { params }).then((res) => {
        if (res.status == 200) {
          this.legalForms = res.data.rows;
          this.total = res.data.total;
        }
      });
    },
    // 获取省份
    getProvinceList() {
      let result = frontHeater(["ClassCode"], ["DistrictCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "DistrictCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "DistrictCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          // this.provinceList = res.data.data;
          let list = res.data.data;
          list.forEach((item) => {
            item.code += "0000";
          });
          this.provinceList = list;
        }
      });
    },
    // 获取性质
    getUnitNatureList() {
      let result = frontHeater(["ClassCode"], ["CollectionNatureCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "CollectionNatureCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "CollectionNatureCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.natureList = res.data.data;
        }
      });
    },
    // 获取质量等级
    getQualityGradeList() {
      let result = frontHeater(["ClassCode"], ["CollectionQualityLevelCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "CollectionQualityLevelCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] =
        "CollectionQualityLevelCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.gradeList = res.data.data;
        }
      });
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataCollection"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataCollection",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] = "DataCollection";
      this.$http.post(Url + `/api/description/find`, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    // 省份改变
    provinceChange() {
      this.getList();
    },
    // 性质改变
    natureChange() {
      this.getList();
    },
    // 质量等级改变
    gradeChange() {
      this.getList();
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.province = null;
      this.nature = null;
      this.grade = null;
      this.currentPage = 1;
      this.getList();
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 表格分页
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
  mounted() {
    this.regulations.laws = this.$route.query.title;
    this.getList();
    this.getProvinceList();
    this.getUnitNatureList();
    this.getQualityGradeList();
    this.getNumberViews();
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";
.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}

.dat {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 10px 0;
  align-items: center;
}
</style>
